<template lang="pug">
  countdown(
    :time='time'
  )
    template(
      slot-scope="{ minutes, seconds }"
    )
      slot(
        :minutes='minutes',
        :seconds='seconds',
      )
</template>
<script>
export default {
  name: 'ResendTimer',
  props: ['time'],
}
</script>
